import SignAdvantageItem from "./SignAdvantageItem"
import styles from "./SignAdvantageItems.module.scss"

function SignAdvantageItems({ items }) {
  return (
    <div className={styles["sign-advantage-items"]}>
      {items.map((item) => (
        <SignAdvantageItem key={item.title} {...item} />
      ))}
    </div>
  )
}

export default SignAdvantageItems
